import router from '../../router';
import {getLangs} from "../../api/langs";
import {i18n} from "../../plugins/i18n";
import {getInfo, getProgress} from "../../api/app";
import Vuetify from '../../plugins/vuetify'
import Vue from 'vue';

const state = {
    app:{
        loading: false,
        errors: [],
        messages:[],
        langs:null,
        statuses: [],
        app_info_initialized:false,
        preview: null,
        progress: null,
        colors:null,
        logo: null,
        bottom:null,
        states:null,
        colors_swatches:null,
    }
};

const actions = {
    getProgress: ({commit, state}, hard = false) => {
        if(state.progress == null || hard){
            getProgress().then(response => {
                state.app.progress = response;
            })
        }
    },
    getLangs: ({commit, state}) => {
        getLangs().then(response => {
           commit('SET_LANGS', response);
            for (var i in state.app.langs){
                i18n.setLocaleMessage(i, state.app.langs[i]);
            }
        })
    },
    getInfo:({commit, state}) => {
        return new Promise((resolve, reject) => {
            getInfo().then(res => {
                state.app.statuses = res.statuses;
                state.app.logo = res.logo;
                state.app.admin_logo = res.admin_logo;
                state.app.states = res.states;
                state.app.countries = res.countries;
                state.app.admin_info = res.admin_info;
                i18n.setLocaleMessage('en', res.lang);
                state.app.app_info_initialized = true;
                state.app.colors_swatches = res.colors_swatches;
                if(res.colors) state.colors = res.colors;
                commit('SET_COLORS');
                resolve(res);
            })
        })
    },
}
const mutations = {
    LOADING_BOTTOM:(state, value) => {
        if(state.app.bottom){
            Vue.set(state.app.bottom, 'loading', value);
        }
    },
    SET_BOTTOM:(state, value) => {
        state.app.bottom = value;
    },
    SET_PREVIEW:(state, value) => {state.app.preview = value},
    SET_LANGS: (state, value) => {
      state.app.langs = value;
    },
    setLoading: (state, value) => {
        state.app.loading= value;
    },
    ADD_MESSAGE: (state, message) => {state.app.messages.unshift(message)},
    RESET_MESSAGES: (state) => {state.app.messages = []},
    SET_COLORS:(state) => {
        if(state.colors && state.colors.primary) Vuetify.framework.theme.themes.light.primary = state.colors.primary;
        if(state.colors && state.colors.secondary) Vuetify.framework.theme.themes.light.secondary = state.colors.secondary;
    }
};

const getters = {
    messages: (state) => {return state.app.messages},
    langs: (state) => {return state.app.langs},
    countries: (state) =>{return state.app.countries_list}

}
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
